import {
  arrayJsonFormat,
  dateJsonFormat,
  JsonFormat,
  numberJsonFormat,
  objectJsonFormat,
  stringEnumJsonFormat,
  stringJsonFormat,
} from "@redotech/json/format";
import {
  CustomerProductListType,
  ICustomerProductList,
  IProductListItem,
} from "./customer-product-list-definition";

const productListItemJsonFormat: JsonFormat<IProductListItem> =
  objectJsonFormat(
    {
      productId: stringJsonFormat,
      productUrl: stringJsonFormat,
      productTitle: stringJsonFormat,
      variantId: stringJsonFormat,
      priceAmount: numberJsonFormat,
      priceCurrencyCode: stringJsonFormat,
      createdAt: dateJsonFormat,
      updatedAt: dateJsonFormat,
    },
    { imageSrcUrl: stringJsonFormat, variantTitle: stringJsonFormat },
  );

export const customerProductListJsonFormat: JsonFormat<ICustomerProductList> =
  objectJsonFormat(
    {
      _id: stringJsonFormat,
      team: stringJsonFormat,
      email: stringJsonFormat,
      listType: stringEnumJsonFormat(CustomerProductListType),
      listName: stringJsonFormat,
      items: arrayJsonFormat(productListItemJsonFormat),
    },
    {},
  );
export const customerProductListArrayJsonFormat: JsonFormat<
  ICustomerProductList[]
> = arrayJsonFormat(customerProductListJsonFormat);
